module.exports = __webpack_public_path__ + "img/presse.bfc07b0a.jpg";